// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/fonts/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/fonts/Gilroy-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Assets/fonts/Gilroy-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'Gilroy-Medium';
	src:
		local('Gilroy-Medium'),
		url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
	font-display: swap;
}
@font-face {
	font-family: 'Gilroy-Regular';
	src:
		local('Gilroy-Regular'),
		url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
	font-display: swap;
}
@font-face {
	font-family: 'Gilroy-SemiBold';
	src:
		local('Gilroy-SemiBold'),
		url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
	font-display: swap;
}

* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	font-family: 'Gilroy-Medium', sans-serif;
}

.semiBold1 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 40px;
	line-height: 46.88px;
	letter-spacing: 0px;
}
.semiBold2 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 34px;
	line-height: 39.84px;
	letter-spacing: 0px;
}
.semiBold3 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 24px;
	line-height: 28.13px;
	letter-spacing: 0px;
}
.semiBold4 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 22px;
	line-height: 25.78px;
	letter-spacing: 0px;
}

.semiBold5 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 20px;
	line-height: 23.44px;
	letter-spacing: 0px;
}
.semiBold6 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 18px;
	line-height: 21.09px;
	letter-spacing: 0px;
}
.semiBold7 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 18px;
	line-height: 16px;
	letter-spacing: 0px;
}
.semiBold8 {
	font-family: 'Gilroy-SemiBold', sans-serif !important;
	font-size: 16px !important;
	line-height: 18.75px;
	letter-spacing: 0px;
}
.semiBold9 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 16px;
	line-height: 18.75px;
	letter-spacing: 0px;
}
.semiBold10 {
	font-family: 'Gilroy-SemiBold', sans-serif !important;
	font-size: 15px !important;
	line-height: 17.58px;
	letter-spacing: 0px;
}
.semiBold11 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 20px;
	line-height: 16px;
	letter-spacing: 0px;
}
.semiBold12 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 48px;
	line-height: normal;
	letter-spacing: 0px;
}
.semiBold13 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 12px;
	line-height: 14.06px;
}
.semiBold14 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}
.semiBold15 {
	font-family: 'Gilroy-SemiBold', sans-serif;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}
.medium1 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 20px;
	line-height: normal;
	letter-spacing: 0px;
}
.medium2 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 18px;
	line-height: 21.09px;
	letter-spacing: 0px;
}
.medium3 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 24px;
	line-height: 28.13px;
	letter-spacing: 0px;
}
.medium4 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 16px;
	line-height: 18.75px;
	letter-spacing: 0px;
}
.medium5 {
	font-family: 'Gilroy-Medium', sans-serif !important;
	font-size: 14px !important;
	line-height: 16.41px;
	letter-spacing: 0px;
}
.medium6 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 14px;
	line-height: 16px;
	letter-spacing: 0px;
}
.medium7 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 12px;
	line-height: 14.06px;
	letter-spacing: 0px;
}
.medium8 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 10px;
	line-height: 11.72px;
	letter-spacing: 0px;
}
.medium9 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 8px;
	line-height: 16px;
	letter-spacing: 0px;
}
.medium10 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.medium11 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}
.medium12 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 20px;
	line-height: 24.26px;
	letter-spacing: 0px;
}

.medium13 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}
.medium14 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 48px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.grey-textcolor {
	color: #8e8e8e;
}
.dark-textcolor {
	color: #21241e !important;
}
.green-color {
	color: #b7d423;
}
.pdf-view_btn {
	background: #b7d423;
	color: black;
	padding: 6px 8px;
	border-radius: 4px;
}

.pdf-view_btn:hover {
	background: #b7d423 !important;
}
.pointer-css {
	cursor: pointer;
}

.ck-iconcenteralign {
	display: grid;
	place-content: center;
}

.dataGrid-value-resp {
	white-space: normal;
	word-wrap: break-word;
	overflow: hidden;
	text-overflow: ellipsis;
}
.medium15 {
	font-family: 'Gilroy-Medium', sans-serif;
	font-size: 36px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,4BAA4B;CAC5B;;4DAEyD;CACzD,kBAAkB;AACnB;AACA;CACC,6BAA6B;CAC7B;;4DAE0D;CAC1D,kBAAkB;AACnB;AACA;CACC,8BAA8B;CAC9B;;4DAE2D;CAC3D,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,UAAU;CACV,sBAAsB;CACtB,wCAAwC;AACzC;;AAEA;CACC,0CAA0C;CAC1C,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,0CAA0C;CAC1C,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,qDAAqD;CACrD,0BAA0B;CAC1B,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,qDAAqD;CACrD,0BAA0B;CAC1B,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,oBAAoB;AACrB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,0CAA0C;CAC1C,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,mDAAmD;CACnD,0BAA0B;CAC1B,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,cAAc;CACd,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,wCAAwC;CACxC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,wCAAwC;CACxC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;AAC/B;AACA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,wCAAwC;CACxC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB","sourcesContent":["@font-face {\n\tfont-family: 'Gilroy-Medium';\n\tsrc:\n\t\tlocal('Gilroy-Medium'),\n\t\turl(./Assets/fonts/Gilroy-Medium.ttf) format('truetype');\n\tfont-display: swap;\n}\n@font-face {\n\tfont-family: 'Gilroy-Regular';\n\tsrc:\n\t\tlocal('Gilroy-Regular'),\n\t\turl(./Assets/fonts/Gilroy-Regular.ttf) format('truetype');\n\tfont-display: swap;\n}\n@font-face {\n\tfont-family: 'Gilroy-SemiBold';\n\tsrc:\n\t\tlocal('Gilroy-SemiBold'),\n\t\turl(./Assets/fonts/Gilroy-SemiBold.ttf) format('truetype');\n\tfont-display: swap;\n}\n\n* {\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n\tfont-family: 'Gilroy-Medium', sans-serif;\n}\n\n.semiBold1 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 40px;\n\tline-height: 46.88px;\n\tletter-spacing: 0px;\n}\n.semiBold2 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 34px;\n\tline-height: 39.84px;\n\tletter-spacing: 0px;\n}\n.semiBold3 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 24px;\n\tline-height: 28.13px;\n\tletter-spacing: 0px;\n}\n.semiBold4 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 22px;\n\tline-height: 25.78px;\n\tletter-spacing: 0px;\n}\n\n.semiBold5 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 20px;\n\tline-height: 23.44px;\n\tletter-spacing: 0px;\n}\n.semiBold6 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 18px;\n\tline-height: 21.09px;\n\tletter-spacing: 0px;\n}\n.semiBold7 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 18px;\n\tline-height: 16px;\n\tletter-spacing: 0px;\n}\n.semiBold8 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif !important;\n\tfont-size: 16px !important;\n\tline-height: 18.75px;\n\tletter-spacing: 0px;\n}\n.semiBold9 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 16px;\n\tline-height: 18.75px;\n\tletter-spacing: 0px;\n}\n.semiBold10 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif !important;\n\tfont-size: 15px !important;\n\tline-height: 17.58px;\n\tletter-spacing: 0px;\n}\n.semiBold11 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 20px;\n\tline-height: 16px;\n\tletter-spacing: 0px;\n}\n.semiBold12 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 48px;\n\tline-height: normal;\n\tletter-spacing: 0px;\n}\n.semiBold13 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 12px;\n\tline-height: 14.06px;\n}\n.semiBold14 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n.semiBold15 {\n\tfont-family: 'Gilroy-SemiBold', sans-serif;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n.medium1 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 20px;\n\tline-height: normal;\n\tletter-spacing: 0px;\n}\n.medium2 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 18px;\n\tline-height: 21.09px;\n\tletter-spacing: 0px;\n}\n.medium3 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 24px;\n\tline-height: 28.13px;\n\tletter-spacing: 0px;\n}\n.medium4 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 16px;\n\tline-height: 18.75px;\n\tletter-spacing: 0px;\n}\n.medium5 {\n\tfont-family: 'Gilroy-Medium', sans-serif !important;\n\tfont-size: 14px !important;\n\tline-height: 16.41px;\n\tletter-spacing: 0px;\n}\n.medium6 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 14px;\n\tline-height: 16px;\n\tletter-spacing: 0px;\n}\n.medium7 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 12px;\n\tline-height: 14.06px;\n\tletter-spacing: 0px;\n}\n.medium8 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 10px;\n\tline-height: 11.72px;\n\tletter-spacing: 0px;\n}\n.medium9 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 8px;\n\tline-height: 16px;\n\tletter-spacing: 0px;\n}\n.medium10 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.medium11 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n.medium12 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 20px;\n\tline-height: 24.26px;\n\tletter-spacing: 0px;\n}\n\n.medium13 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n.medium14 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 48px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.grey-textcolor {\n\tcolor: #8e8e8e;\n}\n.dark-textcolor {\n\tcolor: #21241e !important;\n}\n.green-color {\n\tcolor: #b7d423;\n}\n.pdf-view_btn {\n\tbackground: #b7d423;\n\tcolor: black;\n\tpadding: 6px 8px;\n\tborder-radius: 4px;\n}\n\n.pdf-view_btn:hover {\n\tbackground: #b7d423 !important;\n}\n.pointer-css {\n\tcursor: pointer;\n}\n\n.ck-iconcenteralign {\n\tdisplay: grid;\n\tplace-content: center;\n}\n\n.dataGrid-value-resp {\n\twhite-space: normal;\n\tword-wrap: break-word;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n.medium15 {\n\tfont-family: 'Gilroy-Medium', sans-serif;\n\tfont-size: 36px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
